import React, { createContext, useState, useContext } from "react";

// Criando o contexto
const MenuContext = createContext();

// Provider do Contexto
export const MenuProvider = ({ children }) => {
  const [menuPai, setMenuPai] = useState([]); // Estado para o menu pai
  const [menuFilho, setMenuFilho] = useState([]); // Estado para o menu filho

  // Função para atualizar os menus
  const atualizarMenus = (novosMenuPai, novosMenuFilho) => {
    setMenuPai(novosMenuPai);
    setMenuFilho(novosMenuFilho);
  };

  return (
    <MenuContext.Provider value={{ menuPai, menuFilho, atualizarMenus }}>
      {children}
    </MenuContext.Provider>
  );
};

// Custom Hook para acessar o contexto
export const useMenuContext = () => {
  return useContext(MenuContext);
};
